import React from "react";
import { motion } from "framer-motion";
import { Button } from "@mui/material";
import "./TechJobCard.css";

const TechJobCard = ({ image, title, onClick, variants }) => {
  return (
    <motion.div
      className="techjob-card"
      whileHover={{ y: -8, transition: { duration: 0.2 } }}
      variants={variants}
    >
      <div className="techjob-card-image-container">
        <img src={image} alt={title} className="techjob-card-image" />
      </div>
      <h3 className="techjob-card-title">{title}</h3>
      <Button
        className="techjob-card-button"
        onClick={onClick}
        aria-label={`Explore roles for ${title}`}
      >
        Explore Roles
      </Button>
    </motion.div>
  );
};

export default TechJobCard;
